import { Pagination } from '@/components/table/base'

export type PaginatedResultType<DataType extends object> = {
  data: DataType[]
  pagination: Pagination
}

export const extendFiltersFreeTextData = <DataType extends object>(
  currentStateData: PaginatedResultType<DataType>,
  incomingData: PaginatedResultType<DataType>
) => {
  const current = { ...currentStateData }
  const incoming = { ...incomingData }

  if (incoming?.pagination?.page === 1 || !current.data.length) {
    return incoming
  }

  return {
    data: [...current.data, ...incoming.data],
    pagination: incoming.pagination
  }
}
